module.exports = __webpack_public_path__ + "img/health-advice.cf6545f9.jpg";